export const DATA_SET_CODES = {
  arms_affected_1: 'AA',
  arms_healthy_1: 'AH',
  speech_affected_1: 'SAP',
  speech_healthy_1: 'SHP',
  face_affected_1: 'FA',
  face_affected_bells: 'FAB',
  face_healthy_1: 'FH',
  face_healthy_2: 'FH-90',
  speech_affected_2: 'SA',
  speech_healthy_2: 'SH',
  face_healthy_false_positives: 'FFP',
  face_affected_false_negatives: 'FAN',
};

export const DATA_SET_NAMES = {
  arms_affected_1: 'Arms affected',
  arms_healthy_1: 'Arms healthy',
  speech_affected_1: 'Speech affected',
  speech_healthy_1: 'Speech healthy',
  face_affected_1: 'Face affected',
  face_healthy_1: 'Speech healthy',
};

export const DATA_SETS = [
  { value: 'arms_affected_1', name: 'Arms Affected' },
  { value: 'arms_healthy_1', name: 'Arms Healthy' },
  { value: 'face_affected_1', name: 'Face Affected' },
  { value: 'face_affected_bells', name: 'Face Bells' },
  { value: 'face_healthy_1', name: 'Face Healthy' },
  { value: 'face_healthy_false_positives', name: 'Face  Healthy False Positives' },
  { value: 'face_affected_false_negatives', name: 'Face Affected False Negatives' },
];
